import { useContext, type PropsWithChildren } from 'react';
import * as React from 'react';

import { type Transcription } from '@klangio/ai2notes-ts-client';
import { makeStyles } from 'tss-react/mui';
import { Helmet } from 'react-helmet-async';
import { ComplianzCookieConsent } from '../../components/molecules';
import { type ITheme } from '../../theme';
import { AppConstantsContext } from '../../context';

export const DELAY_RATING_MODAL_TIME_IN_MS = 20 * 1000;

const useStyles = makeStyles()((theme: ITheme) => ({
  app: {
    textAlign: 'center',
    color: '#FFFFFF',
    height: '100%',
    margin: 'auto auto',
    width: '100%',
    maxWidth: '1300px',
  },
  sectionFile: {
    padding: '0 1em',
    textAlign: 'center',
    background: theme.palette.background.default,
    minHeight: '100vh',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
      overflow: 'scroll',
    },
  },
}));

export interface FileWrapperProps extends PropsWithChildren {
  pricingModal: React.ReactNode;
  transcription: Transcription;
}

const FileWrapper: React.FC<FileWrapperProps> = ({ transcription, children, pricingModal }) => {
  const { classes } = useStyles();
  const { title } = useContext(AppConstantsContext);
  // eslint-disable-next-line max-len
  return (
    <>
      <Helmet>
        <title>{transcription ? `${transcription.title} - ${title}` : title}</title>
      </Helmet>
      <ComplianzCookieConsent />

      <div className={classes.app}>
        <section id="section-file" className={classes.sectionFile}>
          {children}
          <br />
        </section>
        {pricingModal}
      </div>
    </>
  );
};

export default FileWrapper;
